import { format, parse, startOfWeek } from "date-fns";

export const getFirstMondayBefore = (date: string) => {
  const parsedDate = parse(date, "yyyy-MM-dd", new Date());
  const firstMondayBefore = startOfWeek(parsedDate, { weekStartsOn: 1 });
  return format(firstMondayBefore, "yyyy-MM-dd");
};
